import { render, staticRenderFns } from "./MantenedorServipagPantalla.vue?vue&type=template&id=3c685286&"
import script from "./MantenedorServipagPantalla.vue?vue&type=script&lang=ts&"
export * from "./MantenedorServipagPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports